module.exports = __webpack_public_path__ + "img/laboratory.60ec88d1.png";